import { CustomPaginationDropdown } from './CustomPaginationDropdown'
import styles from './Styles/index.module.scss'

interface Props {
    totalItems: number
    itemsPerPage: number
    currentPage: number
    onPageChange: (page: number) => void
    onItemsPerPageChange: (page: number) => void
}

export const CustomPagination = ({
    totalItems,
    itemsPerPage,
    currentPage,
    onPageChange,
    onItemsPerPageChange,
}: Props) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage)

    const getPageNumbers = () => {
        const pages = []

        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i)
            }
        } else {
            pages.push(1)

            let startPage = Math.max(2, currentPage - 1)
            let endPage = Math.min(totalPages - 1, currentPage + 1)

            if (currentPage <= 3) {
                endPage = 5
            } else if (currentPage >= totalPages - 2) {
                startPage = totalPages - 4
            }

            if (startPage > 2) {
                pages.push('ellipsis-start')
            }

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i)
            }

            if (endPage < totalPages - 1) {
                pages.push('ellipsis-end')
            }

            pages.push(totalPages)
        }

        return pages
    }

    const pageNumbers = getPageNumbers()
    const startItem = (currentPage - 1) * itemsPerPage + 1
    const endItem = Math.min(currentPage * itemsPerPage, totalItems)

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            onPageChange(page)
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.showing}>
                <strong>Showing</strong> {startItem} - {endItem} of {totalItems}
            </div>
            <CustomPaginationDropdown
                value={itemsPerPage}
                options={[20, 50, 100]}
                onChange={onItemsPerPageChange}
            />
            <ul className={styles.paginationButtonList}>
                <li>
                    <button
                        className={`${styles.prevBtn} ${styles.baseBtn} ${currentPage === 1 && styles.disabledBtn}`}
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        ‹
                    </button>
                </li>
                {pageNumbers.map((page) => {
                    if (
                        typeof page === 'string' &&
                        page.startsWith('ellipsis')
                    ) {
                        return (
                            <li key={page}>
                                <span
                                    className={`${styles.baseBtn} ${styles.disabledBtn}`}
                                >
                                    …
                                </span>
                            </li>
                        )
                    }
                    return (
                        <li key={page}>
                            <button
                                className={`border ${styles.baseBtn} ${currentPage === page && styles.activeBtn}`}
                                onClick={() => handlePageChange(page as number)}
                            >
                                {page}
                            </button>
                        </li>
                    )
                })}
                <li>
                    <button
                        className={`${styles.nextBtn} ${styles.baseBtn} ${currentPage === totalPages && styles.disabledBtn}`}
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        ›
                    </button>
                </li>
            </ul>
        </div>
    )
}
